import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class BeforeLoadingState extends BaseState {
    public begin() {
        GameSignals.beforeLoadingComplete.connect(this.end)
        GameSignals.beforeLoading.emit()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.GET_INIT_RESPONSE_STATE)
    }

    public cleanUp() {
        GameSignals.beforeLoadingComplete.disconnect(this.end)
    }
}
